/**
 * Unilar Black Friday Hero
 * Countdown + estilo do Shopify Forms (shadow DOM).
 */

function parseBlackFridayDate(value) {
  if (!value || !String(value).trim()) return null;

  const normalized = String(value).trim().replace(' ', 'T');
  const parsed = new Date(normalized).getTime();

  return Number.isNaN(parsed) ? null : parsed;
}

function padTimeUnit(value) {
  return String(value).padStart(2, '0');
}

const BF_FORMS_STYLE_VERSION = '23';

/**
 * Layout alvo (desktop):
 * [Nome        ] [E-mail      ] [QUERO]
 * [checkbox consent ................ ]
 */
const UNILAR_BF_FORMS_CSS = `
  :host {
    display: block !important;
    width: 100% !important;
    max-width: none !important;
    --inline-container-max-width: 9999px !important;
    --inline-container-min-height: 0 !important;
    --form-background-color: #ffffff !important;
    --form-text-color: #2b2b2b !important;
    --body-text-color: #ffffff !important;
    --form-placeholder-color: #8a8a8a !important;
    --button-background-color: #f37021 !important;
    --button-text-color: #ffffff !important;
    --button-border-radius: 5px !important;
    --button-padding: 0 1.25rem !important;
    --form-field-border-radius: 5px !important;
    --form-field-padding: 0.75rem !important;
    --form-field-padding-top: 0.75rem !important;
    --form-field-padding-bottom: 0.75rem !important;
    --forms-padding-top: 0 !important;
    --forms-padding-right: 0 !important;
    --forms-padding-bottom: 0 !important;
    --forms-padding-left: 0 !important;
    --container-text-alignment: left !important;
    --forms-accent-color: #f37021 !important;
  }

  :host > * {
    width: 100% !important;
    max-width: none !important;
  }

  [class*="formHeader"] {
    display: none !important;
  }

  /* Mensagem de sucesso — título branco no card escuro */
  [data-testid="banner-success"],
  [class*="formBannerContainer"] {
    color: #ffffff !important;
  }

  [data-testid="banner-success"] h2,
  [class*="formBannerHeading"] {
    color: #ffffff !important;
  }

  [data-testid="banner-success"] [class*="textBody"],
  [data-testid="banner-success"] p {
    color: #ffffff !important;
  }

  /* Reserva oculta do Forms — causava o “buraco” à esquerda */
  [class*="WidthReserve"],
  [class*="widthReserve"],
  form[data-testid="form"] > [aria-hidden="true"] {
    display: none !important;
    flex: 0 0 0 !important;
    width: 0 !important;
    height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
    position: absolute !important;
    pointer-events: none !important;
  }

  form[data-testid="form"] {
    display: flex !important;
    flex-flow: row wrap !important;
    align-items: flex-end !important;
    justify-content: flex-start !important;
    gap: 0.5rem 0.75rem !important;
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }

  form[data-testid="form"] > * {
    box-sizing: border-box !important;
    margin: 0 !important;
    min-width: 0 !important;
  }

  /* Campos de texto/email (ignora captcha) */
  form[data-testid="form"] > *:has(> input:not([type="checkbox"]):not([type="hidden"]):not([type="radio"]):not([type="submit"])):not(:has(textarea[name="h-captcha-response"])):not(:has(iframe[data-hcaptcha-widget-id])) {
    order: 1 !important;
    display: flex !important;
    flex-direction: column-reverse !important;
    align-items: stretch !important;
    justify-content: flex-start !important;
    gap: 0.375rem !important;
    min-width: 0 !important;
  }

  /* Desktop: campos dividem a linha (sem flex-grow no mobile) */
  @media screen and (min-width: 750px) {
    form[data-testid="form"] > *:has(> input:not([type="checkbox"]):not([type="hidden"]):not([type="radio"]):not([type="submit"])):not(:has(textarea[name="h-captcha-response"])):not(:has(iframe[data-hcaptcha-widget-id])) {
      flex: 1 1 10rem !important;
    }
  }

  /* Wrapper vazio do shop-lead-capture não pode ocupar célula/linha do layout */
  form[data-testid="form"] > div:has(> shop-lead-capture) {
    position: absolute !important;
    width: 0 !important;
    height: 0 !important;
    overflow: hidden !important;
  }

  /*
    Telefone:
    Telefone
    [bandeira ▾] [input]
    O container do input vira display:contents para o label ocupar a linha toda, acima da bandeira.
  */
  form[data-testid="form"] > [class*="formPhoneInputContainer"] {
    order: 1 !important;
    position: relative !important;
    display: grid !important;
    grid-template-columns: auto minmax(0, 1fr) !important;
    align-items: end !important;
    gap: 0.375rem 0.5rem !important;
    width: 100% !important;
  }

  /* Lista de países abre para cima e passa do topo do form: os containers do Forms não podem cortar */
  [class*="formContainer"],
  [class*="FormContainer"],
  [class*="_inline_"] {
    overflow: visible !important;
  }

  [class*="formPhoneInputContainer"] [class*="dropdownContainer"] {
    z-index: 30 !important;
    border-radius: 5px !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25) !important;
  }

  [class*="formPhoneInputContainer"] [class*="dropdownContainer"],
  [class*="formPhoneInputContainer"] [class*="optionList"] {
    max-height: 200px !important;
  }

  [class*="formPhoneInputContainer"] > .phone-country-selector {
    grid-column: 1 !important;
    grid-row: 2 !important;
    align-self: end !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  [class*="formPhoneInputContainer"] > [class*="formFieldContainer"] > label {
    grid-column: 1 / -1 !important;
    grid-row: 1 !important;
    justify-self: start !important;
  }

  [class*="formPhoneInputContainer"] > [class*="formFieldContainer"] > input {
    grid-column: 2 !important;
    grid-row: 2 !important;
  }

  [class*="formPhoneInputContainer"] > [class*="formFieldContainer"] > :not(input):not(label) {
    grid-column: 1 / -1 !important;
    grid-row: 3 !important;
  }

  [class*="formPhoneInputContainer"] [class*="selectToggle"] {
    box-sizing: border-box !important;
    display: flex !important;
    align-items: center !important;
    gap: 0.5rem !important;
    height: 3rem !important;
    min-height: 3rem !important;
    margin: 0 !important;
    padding: 0 0.75rem !important;
    border: none !important;
    border-radius: 5px !important;
    background: #ffffff !important;
    cursor: pointer !important;
  }

  [class*="formPhoneInputContainer"] > [class*="formFieldContainer"] {
    display: contents !important;
  }

  /*
    Desktop com telefone:
    [Nome        ] [E-mail             ]
    [Telefone                  ] [QUERO]
    [checkbox consent ................ ]
  */
  @media screen and (min-width: 750px) {
    form[data-testid="form"]:has(> [class*="formPhoneInputContainer"]) {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto !important;
      align-items: end !important;
      gap: 0.75rem !important;
    }

    form[data-testid="form"]:has(> [class*="formPhoneInputContainer"]) > *:has(> #first_name) {
      grid-column: 1 !important;
      grid-row: 1 !important;
    }

    form[data-testid="form"]:has(> [class*="formPhoneInputContainer"]) > *:has(> #email) {
      grid-column: 2 / 4 !important;
      grid-row: 1 !important;
    }

    form[data-testid="form"]:has(> [class*="formPhoneInputContainer"]) > [class*="formPhoneInputContainer"] {
      grid-column: 1 / 3 !important;
      grid-row: 2 !important;
    }

    form[data-testid="form"]:has(> [class*="formPhoneInputContainer"]) > [data-testid="btn-form-submit"] {
      grid-column: 3 !important;
      grid-row: 2 !important;
    }

    form[data-testid="form"]:has(> [class*="formPhoneInputContainer"]) > [class*="consentCheckbox"],
    form[data-testid="form"]:has(> [class*="formPhoneInputContainer"]) > *:has(input[type="checkbox"]) {
      grid-column: 1 / -1 !important;
      grid-row: 3 !important;
      width: auto !important;
    }

    form[data-testid="form"]:has(> [class*="formPhoneInputContainer"]) > [class*="isclaimer"] {
      grid-column: 1 / -1 !important;
    }
  }

  /* Label do Forms fica DEPOIS do input no DOM → column-reverse coloca acima */
  [class*="formInputFieldLabel"] {
    position: static !important;
    inset: auto !important;
    left: auto !important;
    top: auto !important;
    transform: none !important;
    width: auto !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
    color: #ffffff !important;
    font-size: 0.875rem !important;
    font-weight: 500 !important;
    line-height: 1.2 !important;
    pointer-events: none !important;
    z-index: 1 !important;
  }

  [class*="_label_"]:not([class*="formInputFieldLabel"]):not([class*="FileInput"]) {
    display: block !important;
    position: static !important;
    transform: none !important;
    margin: 0 0 0.375rem !important;
    padding: 0 !important;
    color: #ffffff !important;
    font-size: 0.875rem !important;
    font-weight: 500 !important;
    line-height: 1.2 !important;
  }

  input[class*="formInputField"],
  input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="submit"]),
  textarea:not([name="h-captcha-response"]):not([id*="h-captcha"]):not([name*="captcha"]):not([name*="recaptcha"]),
  select {
    all: unset !important;
    display: block !important;
    box-sizing: border-box !important;
    width: 100% !important;
    min-height: 3rem !important;
    height: 3rem !important;
    padding: 0 0.75rem !important;
    border: none !important;
    border-radius: 5px !important;
    background: #ffffff !important;
    color: #2b2b2b !important;
    font-size: 1rem !important;
    line-height: 3rem !important;
    box-shadow: none !important;
    -webkit-appearance: none !important;
  }

  input[class*="formInputField"]::placeholder,
  input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="submit"])::placeholder {
    color: #8a8a8a !important;
    opacity: 1 !important;
  }

  /* hCaptcha / honeypot — nunca mostrar (nosso CSS de textarea quebrava o display:none) */
  textarea[name="h-captcha-response"],
  textarea[id*="h-captcha"],
  textarea[name*="captcha"],
  textarea[name*="recaptcha"],
  input[name*="captcha"],
  input[name*="recaptcha"],
  iframe[data-hcaptcha-widget-id],
  [aria-hidden="true"] iframe,
  section:has(textarea[name="h-captcha-response"]),
  section:has(iframe[data-hcaptcha-widget-id]) {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
    min-height: 0 !important;
    max-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    opacity: 0 !important;
    overflow: hidden !important;
    position: absolute !important;
    pointer-events: none !important;
    border: none !important;
    background: transparent !important;
  }

  /* Botão QUERO — mesma linha dos inputs, texto centralizado */
  form[data-testid="form"] > [data-testid="btn-form-submit"],
  button[data-testid="btn-form-submit"],
  button[class*="formSubmitButton"] {
    all: unset !important;
    box-sizing: border-box !important;
    order: 2 !important;
    flex: 0 0 auto !important;
    align-self: flex-end !important;
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: center !important;
    width: auto !important;
    min-width: 6.75rem !important;
    height: 3rem !important;
    min-height: 3rem !important;
    max-height: 3rem !important;
    margin: 0 !important;
    padding: 0 1.25rem !important;
    border: none !important;
    border-radius: 5px !important;
    background: #f37021 !important;
    color: #ffffff !important;
    font-size: 0.9375rem !important;
    font-weight: 700 !important;
    letter-spacing: 0.06em !important;
    line-height: 1 !important;
    text-align: center !important;
    text-transform: uppercase !important;
    white-space: nowrap !important;
    cursor: pointer !important;
  }

  button[data-testid="btn-form-submit"] *,
  button[class*="formSubmitButton"] * {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1 !important;
    position: static !important;
    transform: none !important;
    float: none !important;
  }

  /*
    Consent / opt-in (checkbox) — NÃO é um input de texto.
    Ficava parecendo um “input branco” largo por herdar estilos de field.
  */
  form[data-testid="form"] > [class*="consentCheckbox"],
  form[data-testid="form"] > *:has(input[type="checkbox"]) {
    flex: 1 1 100% !important;
    width: 100% !important;
    order: 10 !important;
    display: flex !important;
    flex-direction: row !important;
    align-items: flex-start !important;
    gap: 0.5rem !important;
    margin: 0.15rem 12px 0 !important;
    padding: 0 !important;
    background: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    min-height: 0 !important;
    height: auto !important;
  }

  form[data-testid="form"] > [class*="consentCheckbox"] *,
  form[data-testid="form"] > *:has(input[type="checkbox"]) > * {
    background: transparent !important;
    box-shadow: none !important;
  }

  form[data-testid="form"] > [class*="consentCheckbox"] input[type="checkbox"],
  form[data-testid="form"] > *:has(input[type="checkbox"]) input[type="checkbox"] {
    all: revert !important;
    flex: 0 0 auto !important;
    width: 1rem !important;
    height: 1rem !important;
    min-width: 1rem !important;
    min-height: 1rem !important;
    max-height: 1rem !important;
    margin: 0.2rem 0 0 !important;
    padding: 0 !important;
    border-radius: 0.15rem !important;
    accent-color: #f37021 !important;
    background: #ffffff !important;
    appearance: auto !important;
    -webkit-appearance: checkbox !important;
    cursor: pointer !important;
  }

  form[data-testid="form"] > [class*="consentCheckbox"] label,
  form[data-testid="form"] > [class*="consentCheckbox"] span,
  form[data-testid="form"] > [class*="consentCheckbox"] p,
  form[data-testid="form"] > *:has(input[type="checkbox"]) label,
  form[data-testid="form"] > *:has(input[type="checkbox"]) span,
  form[data-testid="form"] > *:has(input[type="checkbox"]) p {
    color: #ffffff !important;
    font-size: 0.875rem !important;
    font-weight: 400 !important;
    line-height: 1.4 !important;
    background: transparent !important;
    height: auto !important;
    min-height: 0 !important;
  }

  form[data-testid="form"] > [class*="isclaimer"] {
    flex: 1 1 100% !important;
    order: 20 !important;
  }

  @media screen and (max-width: 749px) {
    /* Doc Shopify Forms: --inline-container-max-width precisa ser em PX (não %) */
    :host {
      display: block !important;
      width: 100% !important;
      max-width: 9999px !important;
      min-width: 0 !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      margin: 0 !important;
      padding: 0 !important;
      --inline-container-max-width: 9999px !important;
      --inline-container-min-height: 0 !important;
      --forms-padding-top: 0 !important;
      --forms-padding-bottom: 0 !important;
      --forms-padding-left: 0 !important;
      --forms-padding-right: 0 !important;
      --form-field-padding: 10px !important;
      --container-text-alignment: left !important;
    }

    :host > *,
    [data-testid="app-router"],
    [data-testid="form"],
    form[data-testid="form"],
    [class*="formContainer"],
    [class*="FormContainer"],
    [class*="_inline_"],
    [class*="_noImage_"] {
      width: 100% !important;
      max-width: 9999px !important;
      height: auto !important;
      min-height: 0 !important;
      margin: 0 !important;
      margin-inline: 0 !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      box-sizing: border-box !important;
    }

    form[data-testid="form"] > *:has(textarea[name="h-captcha-response"]),
    form[data-testid="form"] > *:has(iframe[data-hcaptcha-widget-id]),
    form[data-testid="form"] > *:has(iframe[src*="hcaptcha"]),
    form[data-testid="form"] > section,
    form[data-testid="form"] > *:has([data-hcaptcha-widget-id]) {
      display: none !important;
      flex: 0 0 0 !important;
      width: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
      position: absolute !important;
      pointer-events: none !important;
    }

    form[data-testid="form"] {
      display: flex !important;
      flex-direction: column !important;
      flex-wrap: nowrap !important;
      align-items: stretch !important;
      justify-content: flex-start !important;
      gap: 12px !important;
      height: auto !important;
      min-height: 0 !important;
      flex: 0 0 auto !important;
    }

    form[data-testid="form"] > * {
      flex: 0 0 auto !important;
      align-self: stretch !important;
      margin: 0 !important;
      min-height: 0 !important;
      height: auto !important;
      width: 100% !important;
      max-width: 9999px !important;
    }

    form[data-testid="form"] > *:has(> input:not([type="checkbox"]):not([type="hidden"])) {
      width: 100% !important;
      max-width: 9999px !important;
      gap: 2px !important;
      display: flex !important;
      flex-direction: column-reverse !important;
      align-items: stretch !important;
    }

    [class*="formInputFieldLabel"],
    [class*="_label_"]:not([class*="formInputFieldLabel"]):not([class*="FileInput"]) {
      margin: 0 !important;
      padding: 0 !important;
      font-size: 13px !important;
      line-height: 1.1 !important;
      text-align: left !important;
      align-self: flex-start !important;
    }

    input[class*="formInputField"],
    input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="submit"]),
    textarea:not([name="h-captcha-response"]):not([id*="h-captcha"]):not([name*="captcha"]):not([name*="recaptcha"]),
    select {
      width: 100% !important;
      max-width: 9999px !important;
      min-height: 42px !important;
      height: 42px !important;
      max-height: 42px !important;
      line-height: 42px !important;
      padding: 0 12px !important;
      margin: 0 !important;
    }

    form[data-testid="form"] > [data-testid="btn-form-submit"],
    button[data-testid="btn-form-submit"],
    button[class*="formSubmitButton"] {
      width: 100% !important;
      max-width: 9999px !important;
      align-self: stretch !important;
      flex: 0 0 auto !important;
      height: 42px !important;
      min-height: 42px !important;
      max-height: 42px !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    form[data-testid="form"] > [class*="consentCheckbox"],
    form[data-testid="form"] > *:has(input[type="checkbox"]) {
      margin: 0 !important;
      padding: 0 !important;
      gap: 6px !important;
      width: 100% !important;
      max-width: 9999px !important;
    }

    form[data-testid="form"] > [class*="isclaimer"] {
      margin: 0 !important;
      padding: 0 !important;
    }

    form[data-testid="form"] > [class*="formPhoneInputContainer"] {
      gap: 2px 8px !important;
    }

    [class*="formPhoneInputContainer"] [class*="selectToggle"] {
      height: 42px !important;
      min-height: 42px !important;
      padding: 0 10px !important;
    }
  }
`;

/**
 * Largura útil do card/form em PX (Forms ignora % em --inline-container-max-width).
 * No mobile deixa ~12px de folga de cada lado.
 */
function getBfFormTargetWidthPx(embed) {
  const formWrap =
    embed.closest?.('[data-bf-shopify-forms]') ||
    document.querySelector('[data-bf-shopify-forms]');
  const card = embed.closest?.('.unilar-bf-hero__card') || formWrap?.closest?.('.unilar-bf-hero__card');
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const sideInset = isMobile ? 24 : 0; /* 12px cada lado */

  let px = 0;
  if (formWrap instanceof HTMLElement && formWrap.clientWidth > 0) {
    px = formWrap.clientWidth - sideInset;
  } else if (card instanceof HTMLElement && card.clientWidth > 0) {
    const style = window.getComputedStyle(card);
    const padL = parseFloat(style.paddingLeft) || 0;
    const padR = parseFloat(style.paddingRight) || 0;
    px = Math.floor(card.clientWidth - padL - padR - sideInset);
  } else {
    px = Math.floor(Math.min(window.innerWidth - 28 - sideInset, 400));
  }

  return Math.max(240, Math.min(px, 560));
}

function applyBfFormsHostWidth(embed) {
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const measured = getBfFormTargetWidthPx(embed);
  const maxPx = isMobile ? `${measured}px` : '9999px';

  embed.style.setProperty('--inline-container-max-width', maxPx, 'important');
  embed.style.setProperty('--inline-container-min-height', '0', 'important');
  embed.style.setProperty('--forms-padding-left', '0px', 'important');
  embed.style.setProperty('--forms-padding-right', '0px', 'important');
  embed.style.setProperty('--forms-padding-top', '0px', 'important');
  embed.style.setProperty('--forms-padding-bottom', '0px', 'important');

  if (isMobile) {
    const widthPx = `${measured}px`;
    embed.style.setProperty('width', widthPx, 'important');
    embed.style.setProperty('max-width', widthPx, 'important');
    embed.style.setProperty('min-width', widthPx, 'important');
    embed.style.setProperty('margin', '0 auto', 'important');
  } else {
    embed.style.setProperty('width', '100%', 'important');
    embed.style.setProperty('max-width', 'none', 'important');
    embed.style.removeProperty('min-width');
    embed.style.setProperty('margin', '0', 'important');
  }

  embed.style.setProperty('display', 'block', 'important');
  embed.style.setProperty('padding', '0', 'important');
}

/** Mobile: aplica largura em PX nos campos (vence CSS do Forms) */
function forceBfFormsMobileFullWidth(embed) {
  if (typeof window.matchMedia !== 'function') return;
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  const measured = getBfFormTargetWidthPx(embed);
  const widthPx = `${measured}px`;
  applyBfFormsHostWidth(embed);

  const shadow = embed.shadowRoot;
  if (!shadow) return;

  const setPxWidth = (el) => {
    if (!(el instanceof HTMLElement)) return;
    el.style.setProperty('width', widthPx, 'important');
    el.style.setProperty('min-width', widthPx, 'important');
    el.style.setProperty('max-width', widthPx, 'important');
    el.style.setProperty('margin-left', '0px', 'important');
    el.style.setProperty('margin-right', '0px', 'important');
    el.style.setProperty('padding-left', '0px', 'important');
    el.style.setProperty('padding-right', '0px', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
  };

  const form =
    shadow.querySelector('form[data-testid="form"]') ||
    shadow.querySelector('form') ||
    shadow.querySelector('[data-testid="form"]');

  if (form instanceof HTMLElement) {
    setPxWidth(form);
    form.style.setProperty('display', 'flex', 'important');
    form.style.setProperty('flex-direction', 'column', 'important');
    form.style.setProperty('align-items', 'stretch', 'important');

    Array.from(form.children).forEach((child) => {
      if (!(child instanceof HTMLElement)) return;
      if (child.querySelector?.('textarea[name="h-captcha-response"], iframe[data-hcaptcha-widget-id]')) {
        return;
      }
      setPxWidth(child);
      child.style.setProperty('align-self', 'stretch', 'important');

      child.querySelectorAll('div').forEach((inner) => {
        if (!(inner instanceof HTMLElement)) return;
        inner.style.setProperty('width', '100%', 'important');
        inner.style.setProperty('max-width', widthPx, 'important');
        inner.style.setProperty('box-sizing', 'border-box', 'important');
      });
    });
  }

  shadow
    .querySelectorAll(
      'input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="submit"]), button[data-testid="btn-form-submit"], button[class*="formSubmitButton"]'
    )
    .forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      const sharesRowWithCountry = Boolean(el.closest('[class*="formPhoneInputContainer"]'));
      el.style.setProperty('width', sharesRowWithCountry ? '100%' : widthPx, 'important');
      el.style.setProperty('min-width', sharesRowWithCountry ? '0px' : widthPx, 'important');
      el.style.setProperty('max-width', sharesRowWithCountry ? '100%' : widthPx, 'important');
      el.style.setProperty('box-sizing', 'border-box', 'important');
      el.style.setProperty('margin-left', '0px', 'important');
      el.style.setProperty('margin-right', '0px', 'important');
    });

  shadow
    .querySelectorAll('[class*="formContainer"], [class*="FormContainer"], [class*="_inline_"], [class*="_noImage_"]')
    .forEach(setPxWidth);
}

/** Placeholders nos inputs do Shopify Forms (shadow DOM) */
function applyBfFormsPlaceholders(embed) {
  const shadow = embed.shadowRoot;
  if (!shadow) return;

  const resolvePlaceholder = (input) => {
    const type = (input.getAttribute('type') || '').toLowerCase();
    const name = `${input.getAttribute('name') || ''} ${input.getAttribute('id') || ''} ${input.getAttribute('autocomplete') || ''}`.toLowerCase();
    const wrap = input.closest('div, label, [class]') || input.parentElement;
    const labelText = (
      wrap?.querySelector?.('[class*="label"], label, [class*="Label"]')?.textContent ||
      ''
    )
      .trim()
      .toLowerCase();

    if (type === 'email' || name.includes('email') || name.includes('e-mail') || labelText.includes('e-mail') || labelText.includes('email')) {
      return 'Escreva seu e-mail';
    }
    if (
      type === 'tel' ||
      name.includes('phone') ||
      name.includes('tel') ||
      labelText.includes('telefone') ||
      labelText.includes('whatsapp')
    ) {
      return '(00) 00000-0000';
    }
    if (name.includes('name') || name.includes('nome') || labelText.includes('nome')) {
      return 'Nome completo';
    }
    return 'Digite aqui';
  };

  shadow
    .querySelectorAll(
      'input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="submit"]):not([type="button"])'
    )
    .forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      const placeholder = resolvePlaceholder(input);
      if (input.getAttribute('placeholder') !== placeholder) {
        input.setAttribute('placeholder', placeholder);
      }
    });
}

function collectBfFormEmbeds(root = document) {
  const embeds = new Set();

  const scan = (node) => {
    if (!(node instanceof Element) && !(node instanceof DocumentFragment) && !(node instanceof ShadowRoot)) {
      return;
    }

    node.querySelectorAll?.('shopify-forms-embed, form-embed').forEach((el) => embeds.add(el));

    node.querySelectorAll?.('*').forEach((el) => {
      if (el.shadowRoot) {
        el.shadowRoot.querySelectorAll('shopify-forms-embed, form-embed').forEach((inner) => {
          embeds.add(inner);
        });
        scan(el.shadowRoot);
      }
    });
  };

  const scopes = [];
  if (root instanceof Element && root.matches?.('[data-bf-shopify-forms]')) {
    scopes.push(root);
  }
  (root.querySelectorAll?.('[data-bf-shopify-forms]') || []).forEach((scope) => scopes.push(scope));
  if (!scopes.length) {
    document.querySelectorAll('[data-bf-shopify-forms]').forEach((scope) => scopes.push(scope));
  }

  scopes.forEach((scope) => scan(scope));
  return [...embeds];
}

function injectBfFormsStyles(embed) {
  if (!(embed instanceof HTMLElement)) return false;

  applyBfFormsHostWidth(embed);

  const shadow = embed.shadowRoot;
  if (!shadow) return false;

  const existing = shadow.querySelector(
    `style[data-unilar-bf-forms="${BF_FORMS_STYLE_VERSION}"]`
  );
  if (!existing || embed.dataset.bfStyled !== BF_FORMS_STYLE_VERSION) {
    shadow.querySelectorAll('style[data-unilar-bf-forms]').forEach((node) => node.remove());

    const style = document.createElement('style');
    style.setAttribute('data-unilar-bf-forms', BF_FORMS_STYLE_VERSION);
    style.textContent = UNILAR_BF_FORMS_CSS;

    embed.__bfFormsInjecting = true;
    try {
      shadow.appendChild(style);

      try {
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(UNILAR_BF_FORMS_CSS);
        const prev = Array.from(shadow.adoptedStyleSheets || []).filter(
          (s) => !s.__unilarBfForms
        );
        sheet.__unilarBfForms = true;
        shadow.adoptedStyleSheets = [...prev, sheet];
      } catch (error) {
        /* ignore — o <style> acima já cobre */
      }
    } finally {
      embed.__bfFormsInjecting = false;
    }

    embed.dataset.bfStyled = BF_FORMS_STYLE_VERSION;
  }

  forceBfFormsMobileFullWidth(embed);
  applyBfFormsPlaceholders(embed);
  return true;
}

function ensureBfFormStylesMap() {
  window.formStyles = window.formStyles || new Map();
  window.formStyles.set('unilar-bf-hero-width', UNILAR_BF_FORMS_CSS);
}

ensureBfFormStylesMap();

function styleUnilarBfShopifyForms(root = document) {
  let styled = 0;

  collectBfFormEmbeds(root).forEach((embed) => {
    if (injectBfFormsStyles(embed)) styled += 1;

    if (embed.shadowRoot && embed.dataset.bfWatch !== 'true') {
      embed.dataset.bfWatch = 'true';
      const observer = new MutationObserver(() => {
        if (embed.__bfFormsInjecting) return;
        forceBfFormsMobileFullWidth(embed);
        applyBfFormsPlaceholders(embed);
        const stillThere = embed.shadowRoot?.querySelector(
          `style[data-unilar-bf-forms="${BF_FORMS_STYLE_VERSION}"]`
        );
        if (stillThere) {
          applyBfFormsHostWidth(embed);
          return;
        }
        delete embed.dataset.bfStyled;
        injectBfFormsStyles(embed);
      });
      observer.observe(embed.shadowRoot, { childList: true, subtree: true });
    }
  });

  return styled;
}

class UnilarBlackFridayHero {
  constructor(section) {
    this.section = section;
    this.countdownEl = section.querySelector('[data-countdown]');
    this.endDate = parseBlackFridayDate(section.dataset.countdownEnd);
    this.countdownInterval = null;
    this.init();
  }

  init() {
    this.initCountdown();
    styleUnilarBfShopifyForms(this.section);
  }

  initCountdown() {
    if (!this.countdownEl || !this.endDate) return;

    const daysEl = this.countdownEl.querySelector('[data-countdown-days]');
    const hoursEl = this.countdownEl.querySelector('[data-countdown-hours]');
    const minutesEl = this.countdownEl.querySelector('[data-countdown-minutes]');
    const secondsEl = this.countdownEl.querySelector('[data-countdown-seconds]');

    const updateCountdown = () => {
      const distance = Math.max(0, this.endDate - Date.now());
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = String(days);
      if (hoursEl) hoursEl.textContent = padTimeUnit(hours);
      if (minutesEl) minutesEl.textContent = padTimeUnit(minutes);
      if (secondsEl) secondsEl.textContent = padTimeUnit(seconds);

      if (distance <= 0) this.stopCountdown();
    };

    updateCountdown();
    this.countdownInterval = setInterval(updateCountdown, 1000);
  }

  stopCountdown() {
    if (!this.countdownInterval) return;
    clearInterval(this.countdownInterval);
    this.countdownInterval = null;
  }
}

function initUnilarBlackFridayHero() {
  document.querySelectorAll('[data-unilar-bf-hero]').forEach((section) => {
    if (!(section instanceof HTMLElement)) return;

    section.querySelectorAll('shopify-forms-embed, form-embed').forEach((embed) => {
      delete embed.dataset.bfStyled;
    });

    if (section.dataset.initialized !== 'true') {
      section.dataset.initialized = 'true';
      new UnilarBlackFridayHero(section);
    } else {
      styleUnilarBfShopifyForms(section);
    }
  });

  styleUnilarBfShopifyForms(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUnilarBlackFridayHero);
} else {
  initUnilarBlackFridayHero();
}

document.addEventListener('shopify:section:load', initUnilarBlackFridayHero);

function observeBfFormsMount() {
  const observer = new MutationObserver(() => styleUnilarBfShopifyForms(document));
  observer.observe(document.body, { childList: true, subtree: true });

  let attempts = 0;
  const retry = window.setInterval(() => {
    attempts += 1;
    const done = styleUnilarBfShopifyForms(document) > 0;
    if (done || attempts >= 20) window.clearInterval(retry);
  }, 400);
}

if (document.body) {
  observeBfFormsMount();
} else {
  document.addEventListener('DOMContentLoaded', observeBfFormsMount);
}

window.addEventListener('resize', () => {
  collectBfFormEmbeds(document).forEach((embed) => forceBfFormsMobileFullWidth(embed));
});
